// @leyro/api-client · errors.js
// Erro normalizado para que web e mobile poidan tratar fallos de API
// dunha forma consistente.

export class ApiError extends Error {
  /**
   * @param {string} message
   * @param {Object} [meta]
   * @param {number} [meta.status]      — HTTP status code (0 se rede caeu)
   * @param {string} [meta.code]        — código de aplicación (ex. "TOKEN_EXPIRED")
   * @param {Array<{msg?: string, message?: string, path?: string}>} [meta.errors]
   *        — array de erros de validación devolto polo backend
   */
  constructor(message, { status = 0, code, errors } = {}) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
    this.errors = errors;
  }

  isUnauthorized() { return this.status === 401; }
  isForbidden()    { return this.status === 403; }
  isNotFound()     { return this.status === 404; }
  isServerError()  { return this.status >= 500; }
  isNetworkError() { return this.status === 0; }
}
